import React, { useState } from "react";
import { Modal, Box, Button, Typography } from "@mui/material";
import toast from "react-hot-toast";
import { uploadSow } from "../../api/nttSowApi";

const UploadSOW = ({ open, setOpen, refetch }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    if (!loading) setOpen(false);
  };

  const handleFileChange = (e) => {
    const selected = e.target.files[0];

    if (!selected) return;

    if (selected.type !== "application/pdf") {
      toast.error("Only PDF files are allowed.");
      return;
    }

    setFile(selected);
  };

 const handleSubmit = async () => {
  if (!file) {
    toast.error("Please select a PDF file.");
    return;
  }

  setLoading(true);

  try {
    // pass the raw file directly
    const res = await uploadSow(file);

    toast.success("SOW uploaded successfully!");
    setOpen(false);
    setFile(null);
    if (refetch) refetch();
  } catch (err) {
    console.error(err);
    toast.error(err?.response?.data?.message || "Upload failed. Try again.");
  } finally {
    setLoading(false);
  }
};


  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          width: 400,
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography variant="h6" sx={{ textAlign: "center", mb: 2 }}>
          Upload SOW (PDF)
        </Typography>

        <input
          type="file"
          accept="application/pdf"
          onChange={handleFileChange}
          style={{
            padding: "10px",
            borderRadius: "6px",
            // border: "1px solid #ccc",
            cursor: "pointer",
          }}
        />

        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            onClick={handleSubmit}
            disabled={loading}
            sx={{
              flex: 1,
              backgroundColor: "#7C2EA0",
              color: "#fff",
              fontSize: 16,
            }}
          >
            {loading ? "Uploading..." : "Submit"}
          </Button>

          <Button
            onClick={handleClose}
            disabled={loading}
            sx={{
              flex: 1,
              backgroundColor: "#7C2EA0",
              color: "#fff",
              fontSize: 16,
            }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default UploadSOW;
